const setIdAttributeToButtons = (firstButtonId, secondButtonId) => {
    try {
     
      if (firstButtonId != "") {
  
        let element1 = document.querySelector('.swal2-confirm');
        if(!element1){
          throw "Primer elemento no encontrado!";
        }
  
        element1.setAttribute('id', firstButtonId);
      }
      
      if (secondButtonId != "") {
        let element2 = document.querySelector('.swal2-cancel');
        if(!element2){
          throw "Segundo elemento no encontrado!";
        }
  
        element2.setAttribute('id', secondButtonId);
      }
  
    } catch (err) {
      console.log("Error: ", err)
    }
  }
    
  const setIdAttributeToModalWindow = (modalId) => {
    try {
  
      let element = document.querySelector('.swal2-container');
      if(!element){
        throw ".swal2-container no encontrado";
      }
  
      element.setAttribute('id', modalId);
    } catch (err) {
      console.log("Error: ", err);
    }
  }
    
  export default {
      setIdAttributeToButtons: setIdAttributeToButtons,
      setIdAttributeToModalWindow: setIdAttributeToModalWindow
  }